import { constantsData, formFieldNamesData } from "@/data";
import { AsyncDataKeyEnum, FieldTypeEnum, InputTypeEnum } from "@/enums";

const {
    name,
    sourceFile,
    type,
} = constantsData.forms.dataSources.setup.offline;

const {
    name: nameFieldName,
    sourceFile: sourceFileFieldName,
    type: typeFieldName,
} = formFieldNamesData;

export const setupOfflineDataSourceFormData = [
    {
        description: name.description,
        label: name.label,
        name: nameFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        dataKey: AsyncDataKeyEnum.TYPES,
        description: type.description,
        hasOptionFormat: true,
        isAsync: true,
        label: type.label,
        name: typeFieldName,
        type: FieldTypeEnum.SELECT,
    },
    {
        accept: ["CSV", "DOC", "DOCX", "XLSX", "XLS"],
        description: sourceFile.description,
        label: sourceFile.label,
        maxSize: 5 * 1024 * 1024,
        multiple: false,
        name: sourceFileFieldName,
        type: FieldTypeEnum.FILE,
    },
];
